export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-05.92603241.jpg";